export const ENDPOINT_SNAPSHOT = 'snapshot'
export const ENDPOINT_NOTIFY = 'notify'
export const ENDPOINT_DEPLOY = 'deploy'
export const ENDPOINT_HAS_DATA = 'has-data'
export const ENDPOINT_UPDATE_SCHEMA = 'update-schema'

export const METHOD_POST = 'POST'
export const METHOD_GET = 'GET'
export const METHOD_PUT = 'PUT'
export const METHOD_DELETE = 'DELETE'

export const API_BASE_URL = 'https://api.askorama.ai'
export const API_V1_BASE_URL = `${API_BASE_URL}/api/v1`
